export const songs = [...Array(1).keys()].map((n) => ({
  title: 'Аудиогид по выставке «Бесконечное место»',
  singer: 'Валерии Амирханян',
  src: 'https://sndup.net/nzky/d',
}));
